import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { CarrierDimensionSpecificationsDto } from '@/types/PackingParcel';

const ENDPOINT = `${APIConfiguration.carrier}carrier/dimensionSpecifications`;

async function getCarrierDimensionSpecificationsQuery(): Promise<
  BackResponse<CarrierDimensionSpecificationsDto[]> | BackResponseFailure
> {
  try {
    const response = await apiCall<
      BackResponse<CarrierDimensionSpecificationsDto[]>
    >(ENDPOINT, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getCarrierDimensionSpecificationsQuery;
